import { Capacitor } from '@capacitor/core';

/**
 * Check if the app is running in a Capacitor native environment.
 * @returns true if running in iOS/Android native app, false if running in web browser
 */
export function isCapacitorNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** Marks `html` so native CSS can disable iOS text selection outside fields. */
export function markNativeShellOnDocument(): void {
  if (typeof document === 'undefined') return;
  if (!Capacitor.isNativePlatform()) return;
  document.documentElement.dataset.nativeShell = Capacitor.getPlatform();
}

function isIosWebKit(): boolean {
  const ua = navigator.userAgent;
  // iPadOS reports a Mac user agent; touch points tell it apart.
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (ua.includes('Macintosh') && navigator.maxTouchPoints > 1)
  );
}

/**
 * The browser keeps pinch zoom (WCAG 1.4.4, DEV-537). The native shell stays
 * fixed-scale as before. iOS Safari gets `maximum-scale=1` only to stop the
 * auto-zoom on focused small inputs; it ignores that value for pinch zoom.
 */
export function applyViewportZoomPolicy(): void {
  if (typeof document === 'undefined') return;
  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) return;
  if (Capacitor.isNativePlatform()) {
    meta.content = `${meta.content}, maximum-scale=1.0, user-scalable=no`;
  } else if (isIosWebKit()) {
    meta.content = `${meta.content}, maximum-scale=1.0`;
  }
}
